module.exports = __webpack_public_path__ + "img/introduction-01.fd227932.png";